module.exports = __webpack_public_path__ + "img/Don't Open.c888cdc3.svg";